import type { IRecord, IRecordTypeDefinition } from '@platform/core/types';
import type { AutosaveAction } from './AutosaveAction';
import { isFieldChange } from './draftChanges';

/** Типи полів, які міні-форма пише в чернетку й зберігає після виходу з поля (як і назву запису). */
const TYPED = ['text', 'textarea', 'number', 'json'];

/**
 * Як міні-форма зберігає значення поля (UIUX forms/form-variants «зміни зберігаються одразу»; рішення 1 етапу 11 за прототипом v4 qr →
 * setVal, де значення, що дорівнює збереженому, не зберігається): назва й текстові поля — у чернетку (commit після виходу з поля зберігає
 * її, лише якщо вона змінює запис); вибір (статус, пріоритет, особа, дата, напрям…) — одразу PATCH, якщо це зміна (isFieldChange), інакше
 * нічого. Зміна — значення, відмінне від збереженого, або повторний вибір чинного виконавця власником чи адміністратором простору
 * (`reassigner`, reassignerOf) — те саме правило, що й «Зберегти · N» повної форми. Чиста функція.
 */
export function autosaveActionOf(rt: IRecordTypeDefinition, record: IRecord, key: string, value: unknown, reassigner?: string): AutosaveAction {
  const field = rt.fields.find((f) => f.key === key);
  if (key === 'title' || (field && TYPED.includes(field.type))) return 'draft';
  return isFieldChange(record, key, value, reassigner) ? 'patch' : 'skip';
}
